import Layout from '@/layout'
import ParentView from '@/components/ParentView'

const asyncPurchaseManagementRoutes = {
  path: '/oa/purchaseManagement',
  component: Layout,
  redirect: 'noredirect',
  name: '采购管理',
  funcPerms: 'oa:purchase',
  alwaysShow: true,
  meta: {
    title: '采购管理',
    icon: 'purchase',
    affix: false,
    noCache: true
  },
  children: [
    {
      path: 'purchaseManagement',
      component: () => import('@/views/oa/purchaseManagement/index.vue'),
      funcPerms: 'oa:purchase:purch',
      name: 'purchaseManagementDefault',
      meta: {
        title: '采购管理',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'index',
      component: () => import('@/views/oa/purchaseManagement/index.vue'),
      funcPerms: 'oa:purchase:purch',
      name: 'purchaseManagement',
      meta: {
        title: '采购管理',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'view',
      component: () => import('@/views/oa/purchaseManagement/view.vue'),
      funcPerms: 'oa:purchase:purch',
      name: 'purchaseManagement-view',
      hidden: true,
      meta: {
        title: '采购管理查看',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'purchaseTask',
      component: ParentView,
      meta: { title: '采购任务', icon: 'index' },
      children: [
        {
          path: 'index',
          component: () => import('@/views/oa/purchaseManagement/purchaseTask/index.vue'),
          funcPerms: 'oa:purchase:task',
          name: 'purchaseTask',
          meta: {
            title: '采购任务',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'next',
          component: () => import('@/views/oa/purchaseManagement/purchaseTask/next.vue'),
          funcPerms: 'oa:purchase:order-detail',
          name: 'purchaseOrder-detail',
          hidden: true,
          meta: {
            title: '采购订单详情',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'view',
          component: () => import('@/views/oa/purchaseManagement/purchaseTask/view.vue'),
          funcPerms: 'oa:purchase:task-view',
          name: 'purchaseTask-view',
          hidden: true,
          meta: {
            title: '采购任务详情',
            icon: 'index',
            affix: false,
            noCache: true
          }
        }
      ]
    },
    {
      path: 'purchaseOrder',
      component: ParentView,
      meta: { title: '采购订单', icon: 'index' },
      children: [
        {
          path: 'index',
          component: () => import('@/views/oa/purchaseManagement/purchaseOrder/index.vue'),
          funcPerms: 'oa:purchase:order',
          name: 'purchaseOrder',
          meta: {
            title: '采购订单',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'view',
          component: () => import('@/views/oa/purchaseManagement/purchaseOrder/view.vue'),
          funcPerms: 'oa:purchase:order',
          name: 'purchaseOrder-view',
          hidden: true,
          meta: {
            title: '查看采购订单',
            icon: 'index',
            affix: false,
            noCache: true
          }
        }
      ]
    },
    {
      path: 'outboundDetails/index',
      component: () => import('@/views/oa/purchaseManagement/outboundDetails/index.vue'),
      funcPerms: 'oa:purchase:outbound',
      name: 'purchase-outboundDetails',
      meta: {
        title: '出库明细',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    {
      path: 'inventoryImport/index',
      component: () => import('@/views/oa/purchaseManagement/inventoryImport/index.vue'),
      funcPerms: 'oa:purchase:inventoryImport',
      name: 'purchase-inventoryImport',
      meta: {
        title: '库存导入',
        icon: 'index',
        affix: false,
        noCache: true
      }
    },
    // 合同
    {
      path: 'contractManagement',
      component: ParentView,
      meta: { title: '合同管理', icon: 'index' },
      children: [
        {
          path: 'index',
          component: () => import('@/views/oa/contractManagement/index'),
          funcPerms: 'oa:room',
          name: 'contractManagement',
          meta: {
            title: '合同管理',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'add',
          component: () => import('@/views/oa/contractManagement/add'),
          funcPerms: 'oa:room',
          name: 'contractManagementAdd',
          hidden: true,
          meta: {
            title: '新增合同',
            icon: 'index',
            affix: false,
            noCache: false
          }
        },
        {
          path: 'audit',
          component: () => import('@/views/oa/contractManagement/audit'),
          funcPerms: 'oa:room',
          name: 'contractManagementAudit',
          meta: {
            title: '合同审核',
            icon: 'index',
            affix: false,
            noCache: true
          }
        },
        {
          path: 'purchaseDetails',
          component: () => import('@/views/oa/contractManagement/purchaseDetails'),
          funcPerms: 'oa:room',
          name: 'contractManagementPurchaseDetails',
          hidden: true,
          meta: {
            title: '查看详情',
            icon: 'index',
            affix: false,
            noCache: false
          }
        }
      ]
    },
    // 分包、合包
    {
      path: 'bagSource',
      component: ParentView,
      meta: { title: '分包/合包管理', icon: 'index' },
      children: [
        {
          path: 'subcontract',
          component: () => import('@/views/oa/bagSource/subcontract.vue'),
          funcPerms: 'oa:room',
          name: 'subcontract',
          hidden: false,
          meta: {
            title: '分包管理',
            icon: 'index',
            affix: false,
            noCache: false
          }
        },
        {
          path: 'packageTogether',
          component: () => import('@/views/oa/bagSource/packageTogether.vue'),
          funcPerms: 'oa:room',
          name: 'packageTogether',
          hidden: false,
          meta: {
            title: '合包管理',
            icon: 'index',
            affix: false,
            noCache: false
          }
        }
      ]
    },
    // 专家库管理
    {
      path: 'expertManagement',
      component: ParentView,
      meta: { title: '专家库管理', icon: 'index' },
      children: [
        {
          path: 'index',
          component: () => import('@/views/oa/expertManagement/index.vue'),
          funcPerms: 'oa:room',
          name: 'expertManagementIndex',
          hidden: false,
          meta: {
            title: '专家库管理',
            icon: 'index',
            affix: false,
            noCache: false
          }
        },
        {
          path: 'add',
          component: () => import('@/views/oa/expertManagement/add.vue'),
          funcPerms: 'oa:room',
          name: 'expertManagementAdd',
          hidden: true,
          meta: {
            title: '新增专家库',
            icon: 'index',
            affix: false,
            noCache: false
          }
        }
      ]
    }
  ]
}

export default asyncPurchaseManagementRoutes
